import { ReactNode } from 'react';
import styles from './Accordion.module.css';
import { Accordion as RadixAccordion } from 'radix-ui';
import { AccordionHeader } from './AccordionHeader';

type AccordionProps = {
  items: {
    subtitle: string;
    title: string;
    description: string;
    content: ReactNode;
  }[];
};

export const Accordion = ({ items }: AccordionProps) => {
  return (
    <RadixAccordion.Root type='multiple' defaultValue={['item-0']}>
      <div className={styles.accordionLayout}>
        {items.map((item, index) => {
          return (
            <RadixAccordion.Item key={index} value={`item-${index}`}>
              <AccordionHeader subtitle={item.subtitle} title={item.title} description={item.description} />
              <RadixAccordion.Content className={styles.accordionContent}>{item.content}</RadixAccordion.Content>
            </RadixAccordion.Item>
          );
        })}
      </div>
    </RadixAccordion.Root>
  );
};
